const checkBoxReducer = (state = 0, action) => {
    switch (action.type) {
        case 'SELECT':
            return state + 1;

        case 'DESELECT':
            return state - 1;
        case 'SELECT_ALL': {
            return action.payload;
        }
        case 'DESELECT_ALL': {
            return 0;
        }
        default:
            return state;
    }
}
export default checkBoxReducer;